// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleServiceAccountCreator = {
  id: "service-account-creator",
  mrn: "//iam.api.mondoo.app/roles/service-account-creator",
  title: "Service Account Creator",
  allowedActions,
} as const;

export type RoleServiceAccountCreator = typeof roleServiceAccountCreator;
